export const API_PATH_apiUserMngmtUserSearch = '/services/users-management/items/search';
